/**
 * @description Common HTTP headers
 * @readonly
 * @type {{CONTENT_LANGUAGE: string, HOST: string, IF_MODIFIED_SINCE: string, DNT: string, FROM: string, CACHE_CONTROL: string, CONTENT_RANGE: string, SERVICE_WORKER: string, IF_RANGE: string, X_FRAME_OPTIONS: string, PING_FROM: string, CONTENT_TYPE: string, X_POWERED_BY: string, PING_TO: string, PRAGMA: string, VARY: string, ALLOW: string, IF_MATCH: string, ACCEPT_ENCODING: string, CONTENT_LOCATION: string, TRANSFER_ENCODING: string, USER_AGENT: string, FORWARDED: string, X_USER_IP: string, ACCEPT_RANGES: string, ACCESS_CONTROL_ALLOW_HEADERS: string, ACCESS_CONTROL_ALLOW_ORIGIN: string, CONTENT_MD5: string, WARNING: string, IF_NONE_MATCH: string, X_FORWARDED_FOR: string, DATE: string, STRICT_TRANSPORT_SECURITY: string, ACCEPT: string, CONTENT_LENGTH: string, ETAG: string, COOKIE: string, X_CONTENT_SECURITY_POLICY: string, X_REQUESTED_WITH: string, RETRY_AFTER: string, X_XSS_PROTECTION: string, TRAILER: string, X_CONTENT_SECURITY_POLICY_REPORT_ONLY: string, X_FORWARDED_PORT: string, RANGE: string, LOCATION: string, PUBLIC_KEY_PINS: string, CONTENT_DISPOSITION: string, REFRESH: string, IF_UNMODIFIED_SINCE: string, PUBLIC_KEY_PINS_REPORT_ONLY: string, LAST_MODIFIED: string, WWW_AUTHENTICATE: string, ACCESS_CONTROL_ALLOW_CREDENTIALS: string, P3P: string, X_WEBKIT_CSP_REPORT_ONLY: string, ORIGIN: string, SET_COOKIE2: string, X_FORWARDED_HOST: string, ACCESS_CONTROL_MAX_AGE: string, TIMING_ALLOW_ORIGIN: string, EXPIRES: string, LAST_EVENT_ID: string, SERVER: string, X_DO_NOT_TRACK: string, X_CONTENT_TYPE_OPTIONS: string, LINK: string, SERVICE_WORKER_ALLOWED: string, FOLLOW_ONLY_WHEN_PRERENDER_SHOWN: string, CONTENT_ENCODING: string, AGE: string, X_WEBKIT_CSP: string, EXPECT: string, ACCESS_CONTROL_REQUEST_METHOD: string, SET_COOKIE: string, CONTENT_SECURITY_POLICY: string, PROXY_AUTHORIZATION: string, VIA: string, ACCESS_CONTROL_REQUEST_HEADERS: string, CONNECTION: string, MAX_FORWARDS: string, TE: string, ACCEPT_LANGUAGE: string, X_FORWARDED_PROTO: string, REFERER: string, ACCEPT_CHARSET: string, ACCESS_CONTROL_ALLOW_METHODS: string, CONTENT_SECURITY_POLICY_REPORT_ONLY: string, UPGRADE: string, PROXY_AUTHENTICATE: string, ACCESS_CONTROL_EXPOSE_HEADERS: string, AUTHORIZATION: string}}
 */
const HTTP_HEADER = {
  ACCEPT: "Accept",
  ACCEPT_CHARSET: "Accept-Charset",
  ACCEPT_ENCODING: "Accept-Encoding",
  ACCEPT_LANGUAGE: "Accept-Language",
  ACCEPT_RANGES: "Accept-Ranges",
  ACCESS_CONTROL_ALLOW_CREDENTIALS: "Access-Control-Allow-Credentials",
  ACCESS_CONTROL_ALLOW_HEADERS: "Access-Control-Allow-Headers",
  ACCESS_CONTROL_ALLOW_METHODS: "Access-Control-Allow-Methods",
  ACCESS_CONTROL_ALLOW_ORIGIN: "Access-Control-Allow-Origin",
  ACCESS_CONTROL_EXPOSE_HEADERS: "Access-Control-Expose-Headers",
  ACCESS_CONTROL_MAX_AGE: "Access-Control-Max-Age",
  ACCESS_CONTROL_REQUEST_HEADERS: "Access-Control-Request-Headers",
  ACCESS_CONTROL_REQUEST_METHOD: "Access-Control-Request-Method",
  AGE: "Age",
  ALLOW: "Allow",
  AUTHORIZATION: "Authorization",
  CACHE_CONTROL: "Cache-Control",
  CONNECTION: "Connection",
  CONTENT_DISPOSITION: "Content-Disposition",
  CONTENT_ENCODING: "Content-Encoding",
  CONTENT_LANGUAGE: "Content-Language",
  CONTENT_LENGTH: "Content-Length",
  CONTENT_LOCATION: "Content-Location",
  CONTENT_MD5: "Content-MD5",
  CONTENT_RANGE: "Content-Range",
  CONTENT_SECURITY_POLICY: "Content-Security-Policy",
  CONTENT_SECURITY_POLICY_REPORT_ONLY: "Content-Security-Policy-Report-Only",
  CONTENT_TYPE: "Content-Type",
  COOKIE: "Cookie",
  DATE: "Date",
  DNT: "DNT",
  ETAG: "ETag",
  EXPECT: "Expect",
  EXPIRES: "Expires",
  FOLLOW_ONLY_WHEN_PRERENDER_SHOWN: "Follow-Only-When-Prerender-Shown",
  FORWARDED: "Forwarded",
  FROM: "From",
  HOST: "Host",
  IF_MATCH: "If-Match",
  IF_MODIFIED_SINCE: "If-Modified-Since",
  IF_NONE_MATCH: "If-None-Match",
  IF_RANGE: "If-Range",
  IF_UNMODIFIED_SINCE: "If-Unmodified-Since",
  LAST_EVENT_ID: "Last-Event-ID",
  LAST_MODIFIED: "Last-Modified",
  LINK: "Link",
  LOCATION: "Location",
  MAX_FORWARDS: "Max-Forwards",
  ORIGIN: "Origin",
  P3P: "P3P",
  PING_FROM: "Ping-From",
  PING_TO: "Ping-To",
  PRAGMA: "Pragma",
  PROXY_AUTHENTICATE: "Proxy-Authenticate",
  PROXY_AUTHORIZATION: "Proxy-Authorization",
  PUBLIC_KEY_PINS: "Public-Key-Pins",
  PUBLIC_KEY_PINS_REPORT_ONLY: "Public-Key-Pins-Report-Only",
  RANGE: "Range",
  REFERER: "Referer",
  REFRESH: "Refresh",
  RETRY_AFTER: "Retry-After",
  SERVER: "Server",
  SERVICE_WORKER: "Service-Worker",
  SERVICE_WORKER_ALLOWED: "Service-Worker-Allowed",
  SET_COOKIE2: "Set-Cookie2",
  SET_COOKIE: "Set-Cookie",
  STRICT_TRANSPORT_SECURITY: "Strict-Transport-Security",
  TE: "TE",
  TIMING_ALLOW_ORIGIN: "Timing-Allow-Origin",
  TRAILER: "Trailer",
  TRANSFER_ENCODING: "Transfer-Encoding",
  UPGRADE: "Upgrade",
  USER_AGENT: "User-Agent",
  VARY: "Vary",
  VIA: "Via",
  WARNING: "Warning",
  WWW_AUTHENTICATE: "WWW-Authenticate",
  X_CONTENT_SECURITY_POLICY: "X-Content-Security-Policy",
  X_CONTENT_SECURITY_POLICY_REPORT_ONLY: "X-Content-Security-Policy-Report-Only",
  X_CONTENT_TYPE_OPTIONS: "X-Content-Type-Options",
  X_DO_NOT_TRACK: "X-Do-Not-Track",
  X_FORWARDED_FOR: "X-Forwarded-For",
  X_FORWARDED_HOST: "X-Forwarded-Host",
  X_FORWARDED_PORT: "X-Forwarded-Port",
  X_FORWARDED_PROTO: "X-Forwarded-Proto",
  X_FRAME_OPTIONS: "X-Frame-Options",
  X_POWERED_BY: "X-Powered-By",
  X_REQUESTED_WITH: "X-Requested-With",
  X_USER_IP: "X-User-IP",
  X_WEBKIT_CSP: "X-WebKit-CSP",
  X_WEBKIT_CSP_REPORT_ONLY: "X-WebKit-CSP-Report-Only",
  X_XSS_PROTECTION: "X-XSS-Protection",
};
Object.freeze(HTTP_HEADER);
Object.seal(HTTP_HEADER);
export { HTTP_HEADER };
